import { Card, Table, Spinner } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';

export function DataTable({ columns, children, loading, emptyMessage = 'Nenhum item encontrado.', emptyIcon: EmptyIcon = FaEye }) {
  return (
    <>
      {loading ? (
        <div className="text-center mt-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Card className="shadow-sm">
          <Card.Body>
            <div className="table-responsive">
              <Table hover>
                <thead>
                  <tr>
                    {columns.map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {children || (
                    <tr>
                      <td colSpan={columns.length} className="text-center text-muted py-5">
                        <EmptyIcon size={40} className="mb-2 opacity-25 d-block mx-auto" />
                        {emptyMessage}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      )}
    </>
  );
}
